import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal
} from '@angular/core';

import { ButtonComponent } from '../button/button.component';
import { ModalCloseDirective } from '../modal/components/modal-close/modal-close-button.directive';
import type { ButtonType } from '../button/button.component';

/**
 * The Confirm Button Component
 *
 * This component is generic confirm button
 */
@Component({
  imports: [
    ButtonComponent,
    ModalCloseDirective
  ],
  selector: 'td-wb-confirm-button',
  templateUrl: 'confirm-button.component.html',
  styleUrls: ['confirm-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmButtonComponent {

  /**
   * Reason for closing
   */
  readonly value: InputSignal<string | undefined> = input<string>();

  /**
   * Type of button. Defaults to secondary
   *
   * @buttonType {string} Button type. Use 'primary' or 'secondary'.
   */
  readonly buttonType: InputSignal<ButtonType> = input<ButtonType>('secondary');
}
